import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { unitStats } from '../../../stats';

export const theaterReducer = (scratch: StatsSnapshot) => {
  const stats = unitStats.theater;
  const generated = stats.buildingsGeneration ?? 0;

  scratch.generators.troupe.owned += generated;

  return;
};
